module.exports = __webpack_public_path__ + "img/badge_color_holistic-holistic.ab55de02.svg";